import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store,history  } from './redux';
import HomeMgtScreen from "./HomeMgtScreen";
import { Route, Switch } from 'react-router' // react-router v4/v5
import { ConnectedRouter } from 'connected-react-router'
import { BrowserRouter } from "react-router-dom";

const el = document.querySelector('#root');
ReactDOM.render(
  
     <Provider store={store}>
     <ConnectedRouter history={history}>
     <BrowserRouter basename="/stockideas/customscreener">       
    
                       <> { /* your usual react-router v4/v5 routing */ }
        <Switch>
          <Route exact path="/"  >     <Home paths={el.dataset.paths} uids={el.dataset.uid}  dod={el.dataset.dod} dodxl={el.dataset.dodxl} uname={el.dataset.uname}   mgt={el.dataset.mgt}  plus={el.dataset.plus}/></Route>
          <Route exact path="/managecreen"  >     <HomeMgtScreen paths={el.dataset.paths} uids={el.dataset.uid}  dod={el.dataset.dod} uname={el.dataset.uname}  mgt={el.dataset.mgt}/></Route>
       {/*    <Route render={() => (<div>404</div>)} /> */}
        </Switch>
      </>


      </BrowserRouter>
    </ConnectedRouter>
    </Provider>
 ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
